"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _localization = require("@lt/localization");
var _react = _interopRequireWildcard(require("react"));
var _FilterItemList = require("./Components/Content/FilterItemList");
var _DesktopContainer = require("./Components/DesktopContainer/DesktopContainer");
var _MobileContainer = require("./Components/MobileContainer/MobileContainer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SearcherAbstractFilters = function SearcherAbstractFilters(props) {
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    _props$onSubmit = props.onSubmit,
    onSubmit = _props$onSubmit === void 0 ? Function.prototype : _props$onSubmit,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? {} : _props$defaultValue,
    _props$label = props.label,
    label = _props$label === void 0 ? "".concat(t('hotel.filters.title')) : _props$label,
    _props$position = props.position,
    position = _props$position === void 0 ? 'center' : _props$position,
    options = props.options,
    isFiltersMobile = props.isFiltersMobile,
    isHotelOnly = props.isHotelOnly,
    _props$isOpenFiltersL = props.isOpenFiltersList,
    isOpenFiltersList = _props$isOpenFiltersL === void 0 ? false : _props$isOpenFiltersL,
    clearSearcherFilters = props.clearSearcherFilters;
  var dropdownRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(defaultValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var handleItemClick = function handleItemClick(event) {
    var id = (0, _get2["default"])(event, 'target.dataset.id');
    var nextValue = _objectSpread(_objectSpread({}, value), {}, (0, _defineProperty2["default"])({}, id, !value[id]));
    setValue(nextValue);
  };
  var handleClickDone = function handleClickDone() {
    closeDropdown();
    setTimeout(handleSubmit, 0); // возможно лучше в приложении сделать таймаут
  };
  var handleSubmit = function handleSubmit() {
    return onSubmit(value);
  };
  var closeDropdown = function closeDropdown() {
    if (dropdownRef && dropdownRef.current) {
      dropdownRef.current.toggle(false);
    }
  };
  if (isMobile) {
    return /*#__PURE__*/_react["default"].createElement(_MobileContainer.MobileContainer, {
      label: label,
      onSubmit: handleSubmit,
      isFiltersMobile: isFiltersMobile,
      isInitialOpen: isOpenFiltersList,
      onClear: clearSearcherFilters
    }, /*#__PURE__*/_react["default"].createElement(_FilterItemList.FilterItemList, {
      options: options,
      value: value,
      handleItemClick: handleItemClick,
      isMobile: isMobile,
      isHotelOnly: isHotelOnly
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_DesktopContainer.DropdownContainer, {
    className: className,
    label: label,
    position: position,
    dropdownRef: dropdownRef,
    isInitialOpen: isOpenFiltersList ? true : undefined
  }, /*#__PURE__*/_react["default"].createElement(_FilterItemList.FilterItemList, {
    handleClickDone: handleClickDone,
    options: options,
    value: value,
    handleItemClick: handleItemClick,
    isMobile: isMobile,
    isHotelOnly: isHotelOnly
  }));
};
var _default = exports["default"] = SearcherAbstractFilters;